import MonthInput from './MonthInput';

export default MonthInput;
